import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import SignupContainer from '../containers/SignupFormContainer';
import SignupSuccess from './Success';

export default ({ basePath }: { basePath: string }) => (
  <Switch>
    <Route exact path={basePath} component={SignupContainer} />
    <Route exact path={`${basePath}/iniciar-teste`} component={SignupSuccess} />
    <Route render={() => <Redirect to={basePath} />} />
  </Switch>
);
